@if (document && messageRelation) {
  <div class="gridview-row">
    <article class="details">
      <app-tracking-message-relations-item [document]="document" [messageRelation]="messageRelation" [original]="true" (openDocument)="openDocument2($event)"
      (openInterchange)="openInterchange2($event)"></app-tracking-message-relations-item>
      <span>{{relation?.RelationText ?? '(null)'}}</span>
      <app-tracking-message-relations-item [document]="document" [messageRelation]="messageRelation" [original]="false" (openDocument)="openDocument2($event)"
      (openInterchange)="openInterchange2($event)"></app-tracking-message-relations-item>
    </article>
    <article class="toolbar">
      <span title="{{relation?.Description ?? '(null)'}}">{{relation?.Name ?? '(null)'}}</span>
      <span
        title="Created date: {{dateTimeService.getDevExpressDateTimeWithMsFunction(messageRelation.CreatedDate)}}">{{dateTimeService.getFormattedTime($safeNavigationMigration(messageRelation?.CreatedDate))}}
        <ep-svg-icon icon="clock"></ep-svg-icon></span>
      </article>
    </div>
  }
